// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** HQ 清分记录列表 GET /api/v1/hq/finance/clearing-records */
export async function FinanceHqClearingControllerListClearingRecordsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqClearingControllerListClearingRecordsV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceClearingRecordDtoArray>(
    "/api/v1/hq/finance/clearing-records",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 清分 N 档明细 GET /api/v1/hq/finance/clearing-records/${param0}/items */
export async function FinanceHqSettlementOpsControllerGetClearingItemsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqSettlementOpsControllerGetClearingItemsV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRecordItemDtoArray>(
    `/api/v1/hq/finance/clearing-records/${param0}/items`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** HQ 清分规则列表 GET /api/v1/hq/finance/clearing-rules */
export async function FinanceHqClearingControllerListClearingRulesV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqClearingControllerListClearingRulesV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDtoArray>(
    "/api/v1/hq/finance/clearing-rules",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 创建清分规则 POST /api/v1/hq/finance/clearing-rules */
export async function FinanceHqClearingControllerCreateClearingRuleV1(
  body: MyApi.CreateFinanceClearingRuleDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    "/api/v1/hq/finance/clearing-rules",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** HQ 清分规则详情 GET /api/v1/hq/finance/clearing-rules/${param0} */
export async function FinanceHqClearingControllerGetClearingRuleV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqClearingControllerGetClearingRuleV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/hq/finance/clearing-rules/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 删除清分规则 DELETE /api/v1/hq/finance/clearing-rules/${param0} */
export async function FinanceHqClearingControllerDeleteClearingRuleV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqClearingControllerDeleteClearingRuleV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/hq/finance/clearing-rules/${param0}`,
    {
      method: "DELETE",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新清分规则 PATCH /api/v1/hq/finance/clearing-rules/${param0} */
export async function FinanceHqClearingControllerUpdateClearingRuleV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqClearingControllerUpdateClearingRuleV1Params,
  body: MyApi.UpdateFinanceClearingRuleDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/hq/finance/clearing-rules/${param0}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 审批通过清分规则 POST /api/v1/hq/finance/clearing-rules/${param0}/approve */
export async function FinanceHqSettlementOpsControllerApproveRuleV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqSettlementOpsControllerApproveRuleV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/hq/finance/clearing-rules/${param0}/approve`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 禁用清分规则（仅已生效规则） POST /api/v1/hq/finance/clearing-rules/${param0}/disable */
export async function FinanceHqClearingControllerDisableClearingRuleV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqClearingControllerDisableClearingRuleV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/hq/finance/clearing-rules/${param0}/disable`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 启用清分规则（仅已生效规则） POST /api/v1/hq/finance/clearing-rules/${param0}/enable */
export async function FinanceHqClearingControllerEnableClearingRuleV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqClearingControllerEnableClearingRuleV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/hq/finance/clearing-rules/${param0}/enable`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 作废已生效清分规则（回退草稿，供租户修改后重新提交） POST /api/v1/hq/finance/clearing-rules/${param0}/invalidate */
export async function FinanceHqSettlementOpsControllerInvalidateRuleV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqSettlementOpsControllerInvalidateRuleV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/hq/finance/clearing-rules/${param0}/invalidate`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 驳回清分规则 POST /api/v1/hq/finance/clearing-rules/${param0}/reject */
export async function FinanceHqSettlementOpsControllerRejectRuleV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqSettlementOpsControllerRejectRuleV1Params,
  body: MyApi.RejectClearingRuleDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/hq/finance/clearing-rules/${param0}/reject`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 提交清分规则审批 POST /api/v1/hq/finance/clearing-rules/${param0}/submit */
export async function FinanceHqSettlementOpsControllerSubmitRuleV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqSettlementOpsControllerSubmitRuleV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/hq/finance/clearing-rules/${param0}/submit`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** HQ 全平台租户保证金 GET /api/v1/hq/finance/deposits */
export async function FinanceHqDepositControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqDepositControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputTenantDepositDtoArray>(
    "/api/v1/hq/finance/deposits",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 获取商户清分配置 GET /api/v1/hq/finance/merchants/${param0}/settlement-config */
export async function FinanceHqParticipantControllerGetSettlementConfigV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqParticipantControllerGetSettlementConfigV1Params,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputMerchantSettlementConfigDto>(
    `/api/v1/hq/finance/merchants/${param0}/settlement-config`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新商户清分配置 PUT /api/v1/hq/finance/merchants/${param0}/settlement-config */
export async function FinanceHqParticipantControllerUpdateSettlementConfigV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqParticipantControllerUpdateSettlementConfigV1Params,
  body: MyApi.UpdateMerchantSettlementConfigDto,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputMerchantSettlementConfigDto>(
    `/api/v1/hq/finance/merchants/${param0}/settlement-config`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** HQ 财务概览（全平台汇总） GET /api/v1/hq/finance/overview */
export async function FinanceHqOverviewControllerGetOverviewV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqOverviewControllerGetOverviewV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceHqOverviewDto>(
    "/api/v1/hq/finance/overview",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** HQ 分账参与方列表 GET /api/v1/hq/finance/participants */
export async function FinanceHqParticipantControllerListParticipantsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqParticipantControllerListParticipantsV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputSettlementParticipantDtoArray>(
    "/api/v1/hq/finance/participants",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 创建分账参与方 POST /api/v1/hq/finance/participants */
export async function FinanceHqParticipantControllerCreateParticipantV1(
  body: MyApi.CreateSettlementParticipantDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputSettlementParticipantDto>(
    "/api/v1/hq/finance/participants",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除分账参与方 DELETE /api/v1/hq/finance/participants/${param0} */
export async function FinanceHqParticipantControllerDeleteParticipantV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqParticipantControllerDeleteParticipantV1Params,
  body: MyApi.DeleteSettlementParticipantDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputSettlementParticipantDto>(
    `/api/v1/hq/finance/participants/${param0}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 更新分账参与方 PATCH /api/v1/hq/finance/participants/${param0} */
export async function FinanceHqParticipantControllerUpdateParticipantV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqParticipantControllerUpdateParticipantV1Params,
  body: MyApi.UpdateSettlementParticipantDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputSettlementParticipantDto>(
    `/api/v1/hq/finance/participants/${param0}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** HQ 全平台支付流水 GET /api/v1/hq/finance/payment-records */
export async function FinanceHqPaymentRecordControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqPaymentRecordControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentRecordDtoArray>(
    "/api/v1/hq/finance/payment-records",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 创建批量打款 POST /api/v1/hq/finance/payout-batches */
export async function FinanceHqSettlementOpsControllerCreatePayoutBatchV1(
  body: MyApi.CreatePayoutBatchDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinancePayoutBatchDto>(
    "/api/v1/hq/finance/payout-batches",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 对账批次列表 GET /api/v1/hq/finance/reconciliation/batches */
export async function FinanceHqReconciliationControllerListBatchesV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqReconciliationControllerListBatchesV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceReconciliationBatchDtoArray>(
    "/api/v1/hq/finance/reconciliation/batches",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 导入通道对账 CSV POST /api/v1/hq/finance/reconciliation/import */
export async function FinanceHqReconciliationControllerImportCsvV1(
  body: MyApi.ImportFinanceReconciliationDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceReconciliationBatchDto>(
    "/api/v1/hq/finance/reconciliation/import",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 处理对账差异 POST /api/v1/hq/finance/reconciliation/items/${param0}/resolve */
export async function FinanceHqReconciliationControllerResolveItemV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqReconciliationControllerResolveItemV1Params,
  body: MyApi.ResolveFinanceReconciliationItemDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceReconciliationItemDto>(
    `/api/v1/hq/finance/reconciliation/items/${param0}/resolve`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** HQ 全平台退款记录 GET /api/v1/hq/finance/refunds */
export async function FinanceHqRefundControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqRefundControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDtoArray>(
    "/api/v1/hq/finance/refunds",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** HQ 结算单列表 GET /api/v1/hq/finance/settlements */
export async function FinanceHqClearingControllerListSettlementsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqClearingControllerListSettlementsV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceSettlementDtoArray>(
    "/api/v1/hq/finance/settlements",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 确认结算单 POST /api/v1/hq/finance/settlements/${param0}/confirm */
export async function FinanceHqClearingControllerConfirmSettlementV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqClearingControllerConfirmSettlementV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceSettlementDto>(
    `/api/v1/hq/finance/settlements/${param0}/confirm`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 完成结算 POST /api/v1/hq/finance/settlements/${param0}/settle */
export async function FinanceHqClearingControllerSettleSettlementV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqClearingControllerSettleSettlementV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceSettlementDto>(
    `/api/v1/hq/finance/settlements/${param0}/settle`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 生成结算单 POST /api/v1/hq/finance/settlements/generate */
export async function FinanceHqClearingControllerGenerateSettlementsV1(
  body: MyApi.GenerateSettlementDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceSettlementDtoArray>(
    "/api/v1/hq/finance/settlements/generate",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** HQ 指定商户分账参与方树 GET /api/v1/hq/finance/tenants/${param0}/participants/tree */
export async function FinanceHqParticipantControllerListMerchantParticipantTreeV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqParticipantControllerListMerchantParticipantTreeV1Params,
  options?: { [key: string]: any }
) {
  const { tId: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputSettlementParticipantDtoArray>(
    `/api/v1/hq/finance/tenants/${param0}/participants/tree`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** HQ 提现申请列表 GET /api/v1/hq/finance/withdrawals */
export async function FinanceHqWithdrawalControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqWithdrawalControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceWithdrawalDtoArray>(
    "/api/v1/hq/finance/withdrawals",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 审核通过提现 POST /api/v1/hq/finance/withdrawals/${param0}/approve */
export async function FinanceHqWithdrawalControllerApproveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqWithdrawalControllerApproveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceWithdrawalDto>(
    `/api/v1/hq/finance/withdrawals/${param0}/approve`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 发起打款 POST /api/v1/hq/finance/withdrawals/${param0}/payout */
export async function FinanceHqWithdrawalControllerPayoutV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqWithdrawalControllerPayoutV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceWithdrawalDto>(
    `/api/v1/hq/finance/withdrawals/${param0}/payout`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 驳回提现 POST /api/v1/hq/finance/withdrawals/${param0}/reject */
export async function FinanceHqWithdrawalControllerRejectV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceHqWithdrawalControllerRejectV1Params,
  body: MyApi.RejectWithdrawalDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceWithdrawalDto>(
    `/api/v1/hq/finance/withdrawals/${param0}/reject`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}
